import {
    request2
} from '../network/request'
import { ProjectId } from '@/common/const.js';
//获取小组列表
export function GetPageList(params) {
    return request2({
        url: '/api2/TZsbAdminApi/Team/GetPageList?a=' + Math.random(),
        method: 'get',
        params: {
            TeamName: params.TeamName,
            pageIndex: params.pageIndex,
            pageSize: params.pageSize,
        }
    })
}
// 获取管理员列表
export function GetAdminList(data) {
    return request2({
        url: '/api7/SBCenterAdminApi/AdminRelevance/GetAdminRolesHeaders',
        method: 'post',
        data: {
            ids: data.ids,
            keyWord: data.keyWord,
            pageSize: data.pageSize,
            adminTypeIds: data.adminTypeIds,
            project: ProjectId
        }
    })
}

// 获取老师接口 /TZsbAdminApi/Admin/PublicAdminList
// export function GetAdminList(data, IsContain=false) {
//     let idsParams = ''
//     let typeParams = ''
//     if(data.ids.length) {
//         data.ids.forEach((id, index) => {
//             if(index === data.ids.length - 1) {
//                 idsParams += `ids=${id}`
//             } else {
//                 idsParams += `ids=${id}&`
//             }
//         });
//     }
//     if (data.adminTypeIds.length) {
//         data.adminTypeIds.forEach((id, index) => {
//             if(index === data.adminTypeIds.length - 1) {
//                 typeParams += `RoleIds=${id}`
//             } else {
//                 typeParams += `RoleIds=${id}&`
//             }
//         });
//     }
//     return request2({
//         url: `/api2/TZsbAdminApi/Admin/PublicAdminList?IsContain=${IsContain}&PageSize=${data.pageSize}&KeyWord=${data.keyWord}&${idsParams}&${typeParams}`,
//         method: "get",
//         params: {}
//     })
// }


//添加招生小组
export function CreateGroup(data) {
    return request2({
        url: '/api2/TZsbAdminApi/Team/Create',
        method: 'post',
        data: {
            teamName: data.teamName,
            superiorId: data.superiorId,
            groupLeaderId: data.groupLeaderId,
            slogan: data.slogan,
            memberIds: data.memberIds,
        }
    })
}
// 编辑招生小组
export function EditGroup(data) {
    return request2({
        url: '/api2/TZsbAdminApi/Team/Edit',
        method: 'post',
        data: {
            id: data.id,
            teamName: data.teamName,
            superiorId: data.superiorId,
            groupLeaderId: data.groupLeaderId,
            slogan: data.slogan,
            memberIds: data.memberIds,
        }
    })
}
// 删除招生小组
export function deleteTeam(id) {
    return request2({
        url: '/api2/TZsbAdminApi/Team/Delete',
        method: 'post',
        params:{
            id:id
        }
    })
}